import React from 'react'

class BurgerBtn extends React.Component {
  render() {
    return (
      <div onClick={this.props.onClick}>
        <svg width="24" height="17" viewBox="0 0 24 17" fill={this.props.active ? "url(#gradient)" : "white"} xmlns="http://www.w3.org/2000/svg">
          {this.props.active && (
            <linearGradient id="gradient" x2="1" y2="1" gradientUnits="userSpaceOnUse">
              <stop offset="15.89%" stopColor="#00FFD1" />
              <stop offset="95.1%" stopColor="#4383FF" />
            </linearGradient>
          )}

          <path d="M0 1.5C0 0.671573 0.671573 0 1.5 0H22.5C23.3284 0 24 0.671573 24 1.5V1.5C24 2.32843 23.3284 3 22.5 3H1.5C0.671573 3 0 2.32843 0 1.5V1.5Z" />
          <path d="M0 8.5C0 7.67157 0.671573 7 1.5 7H22.5C23.3284 7 24 7.67157 24 8.5V8.5C24 9.32843 23.3284 10 22.5 10H1.5C0.671573 10 0 9.32843 0 8.5V8.5Z"  />
          <path d="M0 15.5C0 14.6716 0.671573 14 1.5 14H22.5C23.3284 14 24 14.6716 24 15.5V15.5C24 16.3284 23.3284 17 22.5 17H1.5C0.671573 17 0 16.3284 0 15.5V15.5Z"  />
        </svg>
      </div>
    )
  }
}

export default BurgerBtn